import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#134074',
        secondary: '#2d2940',
        anchor: '#8c9eff',
        error: '#8C031C',
      },
    },
  },
});

export default vuetify;